import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./utilities/axios";

import Header from "./components/Header";
import Dashboard from "./pages/Dashboard/Dashboard";
import Registration from "./pages/Registration/Registration";
import Subscription from "./pages/Subscription/Subscription";
import Users from "./pages/Users/Users";
import UserLink from "./pages/Users/UserLink";
import UsersAnalytics from "./pages/Users/UsersAnalytics";
import Location from "./pages/Location/Location.jsx";
import IpAddress from "./pages/IpAddress/IpAddress.jsx";
import Revenue from "./pages/Revenue/Revenue";
import Transaction from "./pages/Transaction/Transaction";
import StorageUsageDashboard from "./pages/Storage/StorageUsageDashboard.jsx";
import Products from "./pages/Products/Products";
import SubscriptionOverview from "./pages/Subscription/SubscriptionOverview.jsx";
import SubscriptionList from "./pages/Subscription/SubscriptionList.jsx";
import SubscriptionByProduct from "./pages/Subscription/SubscriptionByProduct.jsx";
import Country from "./pages/Location/Country.jsx";
import Storage from "./pages/Storage/Storage.jsx";
import StorageList from "./pages/Storage/StorageList.jsx";
import LocationView from "./pages/Location/LocationOverview.jsx";
import Plans from "./pages/Products/Plans.jsx";
import ProductsLayout from "./pages/Products/ProductsLayout.jsx";
import IpOverview from "./pages/IpAddress/IpOverview.jsx";
import IpAddressList from "./pages/IpAddress/IpAddressList.jsx";
import UserLoginTrackRecord from "./pages/Users/UserLoginTrackRecord.jsx";
import LoginAnalytics from "./pages/Users/LoginAnalytics.jsx";
import "@fontsource/dm-sans";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/400-italic.css";
import Feedback from "./pages/Feedback/Feedback.jsx";
import ComingSoon from "./components/comingSoon.jsx";
import NewComingSoon from "./components/comingSoonNew.jsx";
import ContactQueries from "./pages/Feedback/ContactQueries.jsx";
import Login from "./pages/Auth/Login.jsx";
import Announcements from "./pages/Content/Announcements/Announcements.jsx";
import Content from "./pages/Content/Content.jsx";
import AnnouncementDemo from "./pages/AnnouncementDemo/AnnouncementDemo.jsx";
import Blogs from "./pages/Content/Blogs/Blogs.jsx";
import Offers from "./pages/Content/Offers/Offers.jsx";
import Engagement from "./components/Engagement.jsx";
import ProductOffers from "./pages/Content/ProductOffers/ProductOffers.jsx";
import NotFound from "./pages/NotFound/NotFound.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const location = useLocation();
  const isLogin = location.pathname === "/login";

  return isLogin ? (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  ) : (
    <Header>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/subscription" element={<Subscription />}>
          <Route index element={<SubscriptionOverview />} />
          <Route path="list" element={<SubscriptionList />} />
          <Route path="/subscription/transaction" element={<Transaction />} />
        </Route>
        <Route path="/users" element={<UserLink />}>
          <Route index element={<Users />} />
          <Route path="analytics" element={<UsersAnalytics />} />
        </Route>
        <Route path="/location" element={<Location />}>
          <Route index element={<LocationView />} />
          <Route path="/location/country" element={<Country />} />
          <Route path="/location/ip-address" element={<IpOverview />} />
          <Route index path="/location/ip-address/all" element={<IpAddressList />} />
        </Route>

        <Route path="/engagement" element={<Engagement />}>
          <Route index element={<Feedback />} />
        </Route>

        <Route path="/storage" element={<Storage />}>
          <Route index element={<StorageUsageDashboard />} />
          <Route path="list" element={<StorageList />} />
        </Route>
        <Route path="/products" element={<ProductsLayout />}>
          <Route index element={<ProductOffers />} />
          <Route path="plans" element={<Plans />} />
        </Route>

        <Route path="/content" element={<Content />}>
          <Route index element={<Announcements />} />
          <Route path="offers" element={<Offers />} />
          <Route path="blogs" element={<Blogs />} />
        </Route>
        <Route path="/activity" element={<UserLoginTrackRecord />} />
        <Route path="/activity/analytics" element={<LoginAnalytics />} /> 
        <Route path="/activity/status" element={<ComingSoon />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </Header>
  );
};

export default App;
